module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__11-f9e3142c56211d618c183c6bafa8950e.jpg";